export default {
  selectedYear: '',
  selectedSeason: ''
}
